export default {
  selectedYear: '',
  selectedSeason: ''
}
